<template>
  <v-list v-if="user" flat>
    <v-list-item-group>
      <v-list-item :to="userProfile()">
        <v-list-item-avatar>
          <v-img v-if="user.photoURL" :src="user.photoURL"></v-img>
          <v-icon v-else x-large color="primary">account_circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="user.username" />
        </v-list-item-content>
        <v-list-item-action>
          <v-chip
            v-if="user && user.badge && user.badges.length > 0"
            small
            class="mx-2"
            color="primary"
            v-text="plan_badge(user.badges[0])"
          ></v-chip>
        </v-list-item-action>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  name: "MiniProfile",
  props: {
    user: {
      type: Object,
      default: null
    }
  },

  methods: {
    userProfile() {
      return "/users/" + this.user.username;
    },
    plan_badge(data) {
      if (data.length > 0) {
        let plan = data.split("_", 1)[0];
        return plan;
      }
    }
  }
};
</script>

<style></style>
